module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAolBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACgESU6AAAANXRSTlMAAQIDBAUGCQwNDxAREhMUFyApLzAxMkJHVFlebXF5e4CDm62+xcjKz9PZ3OTo6+/x9/n7/UnKJecAAAB/SURBVBgZBcGJQgEBAAXAcey6tY4KhcpVOgjv/3/NDMDob9MBAIfJ8w4AyktN6gB4WWmkBsD4u+lx3y4BeqcHPpK8wntymwLlTxdJ2gD7CkkKwOAMSQpA5xeSFIDZG2SXArCcQ57SB6QF6//L9WtRNZgcAXTn21vyOQQAzTq4A+uTC/LUhXbmAAAAAElFTkSuQmCC"


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/thumbs_up.png
 ** module id = 294
 ** module chunks = 0 1
 **/